import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from './components/Header';
import './styles/MyAccount.css';
import toast from 'react-hot-toast';
import RespectiveStudent from './components/RespectiveStudent';
import LoadingPage from './components/LoadingPage';
import ErrorPage from './components/ErrorPage';

const MyAccount = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Fetch the current user data
    useEffect(() => {
        const token = localStorage.getItem('jwtToken');

        const fetchUser = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/user/me`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });
                setUser(response.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [API_URL]);

    // If the user decides to logout, remove the session token and navigate to the login page
    const handleLogout = () => {
        localStorage.removeItem('jwtToken');
        navigate('/login');
        toast.success('Logged out successfully!', {
            iconTheme: {
                primary: '#DCB41F',
                secondary: '#333',
            },
            style: {
                backgroundColor: '#333',
                color: '#DCB41F',
            },
        });
    };

    if (loading) return <LoadingPage />;
    if (error) return <ErrorPage />;

    return (
        <div>
            <Header />
            <div className="myaccount-container">
                <h2>My Account</h2>
                {user && (
                    <RespectiveStudent student={user} showLogout={true} onLogout={handleLogout} />
                )}
            </div>
        </div>
    );
};

export default MyAccount;
